<template lang="pug">
	.upload-venatus-media(v-if="showed && Project.SelectedProject")
		.card
			.card-header
				i.fa.fa-edit
				span Venatusmedia.com upload
			.card-body.collapse.show(v-if="state === 'idle'")
				.form-horizontal
					.form-group
						label.col-form-label(for="project-folder") Template folder
							.controls
								input.form-control(id="project-folder" size="16" type="text" v-model="templateFolder")
						label.col-form-label(for="version-folder") Project folder
							.controls
								input.form-control(id="version-folder" size="16" type="text" v-model="projectFolder")
						label.col-form-label Release type
							.controls.input-group(v-pseudo-modal-show="'release-type-dropdown'")
								span.form-control.release-type {{releaseType}}
								.input-group-append
									span.input-group-text
										i.fa.fa-angle-down
							.dropdown-menu.dropdown-menu-right(v-pseudo-modal="'release-type-dropdown'")
								.dropdown-header(class="text-center")
									strong Choose release type
								NetworkList(:callback="chooseReleaseType" scope="upload" :isServer="true")
					.form-result
						span {{previewFileLink}}
					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="upload()")
							i.fa.fa-upload
							| &nbsp;&nbsp;Upload
						button.btn.btn-dark(type="button" v-on:click="hide()") Cancel
			.card-body.collapse.show(v-if="state === 'preparing' || state === 'release' || state === 'uploading'")
				.processing
					.icon.fa.fa-spinner.fa-spin
					.text(v-if="state === 'preparing'") preparing...
					.text(v-if="state === 'release'") creating release...
					.text(v-if="state === 'uploading'") uploading...
			.card-body.collapse.show(v-if="state === 'result'")
				.result
					.text(v-if="result && result.type === 'tag'")
						textarea {{result.data}}
					.text(v-if="result && result.type === 'file-link'")
						a(v-bind:href="resultFileLink" target="_blank") {{resultTag}}
				.form-horizontal
					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="copy()")
							i.fa.fa-copy
							| &nbsp;&nbsp;Copy
						button.btn.btn-dark(type="button" v-on:click="close()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Template } 		from './../../services/Template'
	import { Project } 			from './../../services/Project'
	import { Layout } 			from './../../services/Layout'

	import NetworkList 			from './../Shared/NetworksList'

	import SetupSettings 		from '../../settings/settings'

	export default {
		name: "UploadServer",
		mixins: [Screen],
		screen: {
			events: {
				"Server Upload Progress": function(data) {

					if (data.UploadProjectId === Project.SelectedProject.id) {

						this.state = data.UploadProgress;

						if (data.UploadResult) this.result = data.UploadResult;

						//console.log('this.state', this.state);

						this.update();

					}

				}
			}
		},
		components: {
			NetworkList
		},
		data() {

			this.Template = Template;
			this.Project = Project;
			this.SetupSettings = SetupSettings;

			this.result = {};

			return {
				showed: false,
				state: 'idle', //'preparing', 'release', 'uploading', 'result'
				templateFolder: '',
				projectFolder: '',
				releaseType: 'js-normal'
			};

		},
		computed: {
			previewFileLink() {
				return `https://${SetupSettings['domain']}${SetupSettings['portSSL'] !== 433 ? ':' + SetupSettings['portSSL'] : ''}/releases/${this.templateFolder}/${this.projectFolder}/`;
			},
			resultFileLink() {
				return `https://${SetupSettings['domain']}${SetupSettings['portSSL'] !== 433 ? ':' + SetupSettings['portSSL'] : ''}/releases/${this.result.templateFolder}/${this.result.projectFolder}/${this.result.data}`;
			},
			resultTag() {
				return `<script src="${this.previewFileLink}" async>`;
			}
		},
		methods: {
			collectData() {

				this.templateFolder = Template.SelectedTemplate ? Template.SelectedTemplate.codename : '';
				this.projectFolder = Project.SelectedProject ? Project.SelectedProject.id : this.releaseType;

				this.region = Server.Config['amazon-s3-bucket-region'] || 'eu-central-1';

			},
			upload() {

				Server.sendToSocket({
					UploadCreative: {
						uploadTo: 'server',
						projectId: Project.SelectedProject.id,
						releaseType: this.releaseType,
						templateFolder: this.templateFolder,
						projectFolder: this.projectFolder
					}
				});

				this.state = 'preparing';

			},
			chooseReleaseType(type) {

				this.releaseType = type;

				this.collectData();

				Broadcast.call("Pseudo Modal Hide", ['release-type-dropdown']);

			},
			copy() {

				let text = '';

				if (this.result) {
					if (this.result.type === 'tag') text = this.result.data;
					else if (this.result.type === 'file-link') text = this.resultTag;
				}

				Layout.copyTextToClipboard(text);

			},
			close() {

				this.state = 'idle';

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.upload-venatus-media
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 400px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input
				width: 460px
				margin-top: 5px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

			.form-control.release-type
				cursor: pointer
				width: 150px
				margin-top: 5px
				user-select: none

			.input-group-append
				margin-top: 5px
				cursor: pointer

				.input-group-text
					background-color: #343b41
					border: 1px solid #23282c
					color: #e4e7ea

		.two-setting-panel
			display: flex
			flex-direction: row
			justify-content: space-between

			.setting-one

				.form-control.region
					width: 200px

		.form-result
			color: #20a8d8
			font-size: 11px

		.dropdown-menu
			position: absolute
			right: 44px
			top: auto
			bottom: 114px
			display: block
			z-index: 10000
			line-height: 1.5
			width: 250px
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)

			.dropdown-header
				cursor: default

			.networks
				height: 197px
				overflow-x: hidden
				overflow-y: auto

				.dropdown-item
					white-space: normal
					padding: 0px 20px 10px 20px
					width: 250px

			.networks::-webkit-scrollbar
				width: 10px
				margin-left: -10px
				-webkit-appearance: none
				appearance: none

			.networks::-webkit-scrollbar-track
				background-color: rgba(255,255,255,0.3)
				border-right: 1px solid #f2f2f2
				border-left: 1px solid #f2f2f2

			.networks::-webkit-scrollbar-thumb
				height: 50px
				background-color: rgba(255,255,255,0.2)
				background-clip: content-box
				border-color: transparent
				border-style: solid
				border-width: 1px 2px

		.processing
			height: 100%
			display: flex
			flex-direction: column
			align-items: center
			justify-content: center

			.icon
				display: inline
				font-size: 30px

		.result

			textarea
				width: 100%
				height: 250px
				background: transparent
				border: none
				color: #fff
				font-size: 12px
				white-space: pre
				overflow-wrap: normal
				overflow-x: auto
</style>

